import { UserPermissionsReturnType } from "@hooks/userUserPermission";
import { AnalysisUserType } from "@models/platform-analysis/entities/analysis";
import { SelectRateCard } from "@models/rate-card/entities/selectRateCard";
import { SelectedFamilyMemberDTO } from "@models/reviews/entities/steps/setup";
import { AnalysisStep } from "../../enums/step";

export class AnalysisSetupDTO {
  ownerId: string = "";
  ownerName: string = "";
  ownerType: string = "";
  ownerAvatarUrl: string = "";
  supplierId: string = "";
  supplierName: string = "";
  name: string = "";
  hasFeatureStep: boolean = false;
  hasBusinessMetricStep: boolean = false;
  hasFeeStep: boolean = false;
  hasRefreshData: boolean = false;
  adviserName: string = "";
  practiceName: string = "";
  objectives?: string = "";
  mainProductId: string | null = null;
  otherProductIds: string[] = [];
  loadTemplateId?: string = "";
  loadAnalysisId?: string = "";
  hasMainProduct?: boolean = false;
  hasSteps: AnalysisStep[] = [];
  hasRateCard?: boolean = false;
  selectRateCards: SelectRateCard[] = [];
  familyGroupId?: string;
  familyGroupName?: string;
  selectedFamilyMemberIds?: string[] | null;
  selectedFamilyMembers?: SelectedFamilyMemberDTO[];
  adviserFirmId?: string;
  adviserFirmName?: string;
}

export type AnalysisSetupStepRenderedFieldProps = {
  userType: AnalysisUserType;
  disabled?: boolean;

  [key: string]: any;
};

export type AnalysisSetupStepTitles = {
  supplier?: string;
  adviser?: string;
};

export interface SetupStepRenderSectionConfig {
  name?: string;
  titles: { main: AnalysisSetupStepTitles; subTitle?: AnalysisSetupStepTitles };
  showFor: AnalysisUserType[];
  specificPermissions?: (keyof UserPermissionsReturnType)[];
  fields: AnalysisSetupStepField[];
  dependencyField?: keyof AnalysisSetupDTO;
}

export interface AnalysisSetupStepField {
  showFor: AnalysisUserType[];
  renderComponent: (
    props: AnalysisSetupStepRenderedFieldProps,
  ) => JSX.Element | null;
}
